import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-tool-head',
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.scss']
})
export class HeadComponent {
 @Input('title') title: string;
}
